import { Box, Flex, ScaleFade } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { HeaderUp } from '../../../components/_components_0.2/Header_0.2';

// esqueleto das telas do posto: cabeçalho do samasc sem menu lateral
// (no celular sobra espaço para o que importa).
export function FuelShell({
  children,
  maxW = 1480,
}: {
  children: ReactNode;
  maxW?: number | string;
}) {
  return (
    <ScaleFade initialScale={0.95} in>
      <Flex direction="column" minH="100vh">
        <HeaderUp path="home" />
        <Box
          w="100%"
          maxW={maxW}
          mx="auto"
          px={{ base: '4', md: '6' }}
          pt={{ base: '2', md: '6' }}
          pb="10"
        >
          {children}
        </Box>
      </Flex>
    </ScaleFade>
  );
}
